/** Liquid Cargo dynamic table — columns discovered from API response keys. */

import {
  buildDynamicDataTable,
  DynamicDataTableResult,
  getDynamicTableDisplayValue,
  resolveLiquidCargoRows,
} from 'src/app/shared/helpers/dynamic-data-table.util';

export const LIQUID_CARGO_PREFERRED_COLUMN_ORDER = [
  'DES',
  '98%FULL (m3)',
  'VNET (m3)',
  'CGX (m)',
  'CGY (m)',
  'CGZ (m)',
  'IY/IMO (tm)',
  'PURP',
];

export const LIQUID_CARGO_EMPTY_MESSAGE = 'No Liquid Cargo Data Available';

export { getDynamicTableDisplayValue as getLiquidCargoDisplayValue };
export { resolveLiquidCargoRows };

export function buildLiquidCargoDynamicTable(
  source: unknown,
): DynamicDataTableResult | null {
  const rawRows = resolveLiquidCargoRows(source);
  if (!rawRows.length) {
    return null;
  }

  return buildDynamicDataTable(rawRows, {
    preferredColumnOrder: LIQUID_CARGO_PREFERRED_COLUMN_ORDER,
  });
}

/** @deprecated Use buildLiquidCargoDynamicTable — returns display rows for legacy callers. */
export function buildLiquidCargoDisplayRows(liquidCargo: unknown): string[][] {
  return buildLiquidCargoDynamicTable(liquidCargo)?.rows ?? [];
}
